import React, { useEffect, useState } from "react";
import { placeholderMapping } from "../../../utils/placeholderMapping";
import useStyles from "../../../components/common/model/styles";
import {
  Alert,
  DialogContent,
  DialogContentText,
  Grid,
  Tab,
  Tabs,
  Button,
  ButtonGroup,
  Menu,
  MenuItem,
} from "@mui/material";

import Popup from "../../../components/common/model/Popup";
import FormField from "../../../components/common/FormField";
import { surveryAllFields, surveryEventAllFields } from "./diaryAllFields";
import { useDispatch } from "react-redux";
import Validation from "../../../utils/Validation";
import closeIcon from "../../../assets/closeModel.png";
import checkedIcon from "../../../assets/check-mark.png";
import deleteIcon from "../../../assets/trash.png";
import dayjs from "../../../utils/dayjsConfig";
import { useSelector } from "react-redux";
import {
  addSurveyDiaryAction,
  addSurveyEventAction,
  deleteSurveyEventAction,
  getLeadToSurveyAction,
  getSingleSurveyAction,
  getSingleSurveyEventAction,
  getSurvoyerListAction,
  initialSurveyEventLocalState,
  resetNewSurveyAction,
  resetNewSurveyEventAction,
  setAddSurveyDiaryResponse,
  setNewSurveyAction,
  setNewSurveyEventAction,
  setSingleSurveyAction,
  setUpdateSurveyDiaryResponse,
  updateSurveyDiaryAction,
  updateSurveyEventAction,
} from "../../../store/reducers/surveyDiarySlice";
import Notification from "../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import ResetFormAlert from "./ResetFormAlert";
import CustomButton from "../../../components/common/button/CustomButton";
import { getClientForEditAction } from "../../../store/reducers/adminClientsSlice";
import {
  getAllEmailTemplatesAction,
  leadSendEmailTemplateAction,
} from "../../../store/reducers/emailTemplateSlice";
import {
  getSmsTemplateAction,
  sendSmsTemplateAction,
} from "../../../store/reducers/templateSlice";
import { useLocation } from "react-router-dom";
interface surveyDetail {
  surveyorId: string | null;
  surveyType: string | null;
  remarks: string | null;
  surveyDate: string | null;
  startTime: string | null;
  endTime: string | null;
  description: string | null;
  [key: string]: string | null; // Add index signature
}

interface ManageSurveyAppointmentProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectedSurvey?: any; // Adjust type as per your requirement
  selectedDate?: any;
  surveyorType?: any;
  tabValue?: any;
  selectedResource?: any;
  isReassignAction?: boolean;
  onGoToCustomer?: (leadId: string) => void;
}

const ManageSurveyAppointment: React.FC<ManageSurveyAppointmentProps> = (
  props,
) => {
  const {
    selectedSurvey,
    onHide,
    open,
    title,
    selectedDate,
    surveyorType,
    tabValue,
    selectedResource,
    isReassignAction,
    onGoToCustomer,
  } = props;

  const initialSurveyDetail = {
    surveyorId: "",
    leadId: "",
    surveyType: "",
    remarks: "",
    surveyDate: "",
    startTime: "",
    endTime: "",
    description: "",
  };
  // surveyDetail is a state variable to store the survey details
  const [surveyDetail, setSurveyDetail] =
    useState<surveyDetail>(initialSurveyDetail);
  // surveyEventDetail is a state variable to store the survey event details
  const [surveyEventDetail, setSurveyEventDetail] = useState<any>(
    initialSurveyEventLocalState,
  );

  const { editClientOriginalData } = useSelector(
    (state: any) => state.adminClients,
  );

  const { user, permissions } = useSelector((state: any) => state?.user);

  // State for dropdown menus
  const [emailAnchorEl, setEmailAnchorEl] = useState<null | HTMLElement>(null);
  const [smsAnchorEl, setSmsAnchorEl] = useState<null | HTMLElement>(null);

  const location = useLocation();

const isDashboard = location.pathname === "/dashboard";

  // Handlers for template selection
  const handleEmailTemplateSelect = (template: any) => {
    setEmailAnchorEl(null);
    // TODO: Implement sending email with selected template
    console.log("Selected Email Template:", template);
    console.log("selectedSurvey", selectedSurvey);
    dispatch(
      leadSendEmailTemplateAction({
        templateId: template?.template_id || "",
        leadId: leadDetails?.lead?.generated_id || "",
        surveyId: selectedSurvey || "",
        to: leadDetails?.lead?.email || "",
        template_from: template?.template_from,
        cc: [],
        bcc: [],
      }),
    );
  };
  const handleSmsTemplateSelect = (template: any) => {
    setSmsAnchorEl(null);
    // Build a nested data object matching placeholderMapping
    const data = {
      lead: {
        customer_name: leadDetails?.lead?.customer_name || "",
        customer_email: leadDetails?.lead?.customer_email || "",
        customer_phone: leadDetails?.lead?.customer_phone || "",
        client_id: leadDetails?.lead?.client_id || "",
        created_at: leadDetails?.lead?.created_at || "",
        collection_volume: leadDetails?.lead?.collection_volume || "",
        collection_address: leadDetails?.lead?.collection_address || [],
        delivery_address: leadDetails?.lead?.delivery_address || "",
        materials_table: leadDetails?.lead?.materials_table || "",
        material_included: leadDetails?.lead?.material_included || "",
        services_table: leadDetails?.lead?.services_table || "",
        signature: leadDetails?.lead?.signature || "",
        generated_id: leadDetails?.lead?.generated_id || "",
      },
      editClientOriginalData: {
        email: editClientOriginalData?.email || "",
        contact_name: editClientOriginalData?.contact_name || "",
        address: editClientOriginalData?.address || "",
        website: editClientOriginalData?.website || "",
        company_name: editClientOriginalData?.company_name || "",
        phone_number: editClientOriginalData?.phone_number || "",
      },
    };
    // If template.body is not present, fallback to template.label for demo
    const message = replacePlaceholders(template.body || template.label, data);
    // Now use 'message' to send SMS or preview
    console.log("SMS to send:", message);
    // Call API to send SMS
    dispatch(
      sendSmsTemplateAction({
        to: leadDetails?.lead?.customer_phone || "",
        message: message,
      }),
    );
  };

  // Utility to replace placeholders in template strings
  function replacePlaceholders(template: string, data: Record<string, any>) {
    return template.replace(/{{(.*?)}}/g, (_, key) => {
      const trimmedKey = key.trim();
      const dataPath = placeholderMapping[trimmedKey];
      if (!dataPath) return "";
      // Support nested paths like 'lead.customer_name' or 'lead.collection_address[0].address'
      try {
        const value = dataPath.split(".").reduce((acc, part) => {
          // Handle array index, e.g., collection_address[0].address
          const match = part.match(/(\w+)\[(\d+)\]/);
          if (match) {
            const arr = acc?.[match[1]];
            if (Array.isArray(arr)) {
              return arr[parseInt(match[2], 10)];
            }
            return undefined;
          }
          return acc?.[part];
        }, data);
        return value !== undefined && value !== null ? String(value) : "";
      } catch {
        return "";
      }
    });
  }

 
  const clientTimeZone = editClientOriginalData?.timezone || "UTC";

  const toClientUtcIsoFromWallClock = (value: any) =>
    dayjs
      .tz(dayjs(value).format("YYYY-MM-DDTHH:mm:ss"), clientTimeZone)
      .utc()
      .toISOString();

  const toUtcIsoFromApiDate = (value: any) =>
    value ? dayjs.utc(value).toISOString() : "";

  const dispatch = useDispatch();

  const {
    surveyorList,
    newSurveyLocal,
    isSurveyDiarySuccess,
    isSurveyDiaryUpdateSuccess,
    isSurveyEventSuccess,
    surveyDiaryDetail,
    newEventLocal,
    surveyDiaryEventDetail,
  } = useSelector((state: any) => state?.surveyDiary);

  const { allEmailTemplates } = useSelector(
    (state: any) => state.emailTemplates,
  );
  const { smsTemplates } = useSelector((state: any) => state.template);

  const [leadDetails, setLeadDetails] = useState<any>(null);
  useEffect(() => {
    const stored = sessionStorage.getItem("leadDetails");
    setLeadDetails(stored ? JSON.parse(stored) : null);
    dispatch(getClientForEditAction());
  }, [open]);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    surveyorId: newSurveyLocal?.survey?.surveyorId,
    surveyType: newSurveyLocal?.survey?.surveyType,
    startTime: newSurveyLocal?.survey?.startTime,
    // endTime: newSurveyLocal?.survey?.endTime,
    customer_name: newSurveyLocal?.survey?.customer_name,
  });

  const [
    eventErrors,
    checkEventValidator,
    resetEventValidator,
    resetAllEventValidator,
    isEventError,
  ]: any = Validation({
    eventType: newEventLocal?.eventType,
    startDate: newEventLocal?.startDate,
    endDate: newEventLocal?.endDate,
  });

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);
  const [fullWidth] = useState(true);
  const [maxWidth] = useState<"sm" | "xs" | "md" | "lg" | "xl" | false>("sm"); // Adjust the type definition
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [isEventActionCalled, setIsEventActionCalled] = useState(false);
  const [disabledForm, setDisabledForm] = useState(false);
  const [value, setValue] = useState(tabValue);
  const classes = useStyles();
  const normalizedLeadStatus = leadDetails?.lead?.status?.toUpperCase()?.trim();
  const editableAppointmentLeadStatuses = [
    "NEW LEAD",
    "NEW",
    "ESTIMATES",
    "ESTIMATE",
    "SURVEY",
    "SURVEYED",
    "QUOTE",
    "PROVISIONAL",
    "CONFIRMED",
    "AWAITING",
  ];
  const canEditAppointmentForLeadStatus =
    editableAppointmentLeadStatuses.includes(normalizedLeadStatus || "");
  const isEventFormDisabled = disabledForm;
  const isAppointmentFormDisabled =
    !canEditAppointmentForLeadStatus || disabledForm;

  // check user role
  const [userProfile, setUserProfile] = useState<any>(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUserProfile(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    if (
      surveyDiaryDetail?.status === "STARTED" ||
      surveyDiaryDetail?.status === "IN PROGRESS" ||
      surveyDiaryDetail?.status === "COMPLETED"
    ) {
      setDisabledForm(true);
    } else {
      setDisabledForm(false);
    }
  }, [surveyDiaryDetail, leadDetails]);

  useEffect(() => {
    if (surveyDiaryDetail || isClickReset) {
      const startTimeUtcIso = surveyDiaryDetail?.start_time
        ? dayjs.utc(surveyDiaryDetail?.start_time).toISOString()
        : "";
      const endTimeUtcIso = surveyDiaryDetail?.end_time
        ? dayjs.utc(surveyDiaryDetail?.end_time).toISOString()
        : "";

      dispatch(
        setNewSurveyAction({
          survey: {
            ...surveyDiaryDetail,
            surveyorId:
              isClickReset && isReassignAction
                ? null
                : surveyDiaryDetail?.surveyor_id,
            surveyType:
              isClickReset && isReassignAction
                ? null
                : surveyDiaryDetail?.survey_type,
            leadId: surveyDiaryDetail?.leadId,
            surveyDate: dayjs(surveyDiaryDetail?.start_time).format(
              "YYYY-MM-DD",
            ),
            startTime: startTimeUtcIso,
            endTime: endTimeUtcIso,
            // startTime: surveyDiaryDetail?.start_time,
            // endTime: surveyDiaryDetail?.end_time,
            customer_name: surveyDiaryDetail?.customerName,
            // description: cleanedDescription,
            description: surveyDiaryDetail?.description,
          },
        }),
      );
      setSurveyDetail((prevDetails) => ({
        ...prevDetails,
        surveyorId:
          isClickReset && isReassignAction
            ? null
            : surveyDiaryDetail?.surveyor_id,
        surveyType:
          isClickReset && isReassignAction
            ? null
            : surveyDiaryDetail?.survey_type,
        leadId: surveyDiaryDetail?.leadId,
        surveyDate: dayjs(surveyDiaryDetail?.start_time).format("YYYY-MM-DD"),
        startTime: startTimeUtcIso,
        endTime: endTimeUtcIso,
        // startTime: surveyDiaryDetail?.start_time,
        // endTime: surveyDiaryDetail?.end_time,
        description: surveyDiaryDetail?.description,
      }));
    }
  }, [surveyDiaryDetail, isClickReset]);

  useEffect(() => {
    if (!leadDetails?.lead) return; // ⛔ Exit early if leadDetails or lead is missing
  
    if ((open || isClickReset) && !surveyDiaryDetail) {
      const addresses = leadDetails.lead.collection_address || [];

      const formattedAddresses = addresses
        .map((addr: any, index: number) => {
          const street = addr?.street || "";
          const town = addr?.town || "";
          const country = addr?.country || "";
          const postcode = addr?.postcode || "";

          return `\nAddress ${
            index + 1
          } : ${street}, ${town}, ${country}, ${postcode}`;
        })
        .join("\n");

      const description = `Client Email : ${
        leadDetails.lead.customer_email
      }\nMobile :  ${
        leadDetails.lead.customer_country_code &&
        leadDetails.lead.customer_phone
          ? `${leadDetails.lead.customer_country_code}${leadDetails.lead.customer_phone}`
          : `${leadDetails.lead.customer_phone ? leadDetails.lead.customer_phone : ""}`
      }${formattedAddresses}`;

      setSurveyDetail((prevDetails) => ({
        ...prevDetails,
        customer_name: leadDetails.lead.customer_name,
        leadId: leadDetails.lead.generated_id,
        description,
        surveyorId:
          surveyorType === "self"
            ? userProfile?.user?.staff_id
            : selectedResource?.id || "",
      }));

      dispatch(
        setNewSurveyAction({
          survey: {
            ...newSurveyLocal?.survey,
            // surveyorId:
            customer_name: leadDetails.lead.customer_name,
            leadId: leadDetails.lead.generated_id,
            description,
            surveyorId:
              surveyorType === "self"
                ? userProfile?.user?.staff_id
                : selectedResource?.id || "",
          },
        }),
      );
    }
  }, [surveyDiaryDetail, leadDetails, open, isClickReset]);

  useEffect(() => {
    dispatch(getSurvoyerListAction());
    // dispatch(getLeadToSurveyAction());
    dispatch(getAllEmailTemplatesAction({ lead_stage: "SURVEY" }));
    dispatch(getSmsTemplateAction());
  }, []);

  useEffect(() => {
    if (
      isSurveyDiarySuccess ||
      isSurveyDiaryUpdateSuccess ||
      isSurveyEventSuccess
    ) {
      hideHandler();
    }
  }, [isSurveyDiarySuccess, isSurveyDiaryUpdateSuccess, isSurveyEventSuccess]);

  useEffect(() => {
    if (selectedDate) {
      const startTimeUtcIso = toClientUtcIsoFromWallClock(selectedDate);
      const endTimeUtcIso = dayjs(startTimeUtcIso)
        .add(60, "minute")
        .toISOString();

      setSurveyDetail((prevDetails) => ({
        ...prevDetails,
        surveyDate: dayjs(selectedDate).format("YYYY-MM-DD"),
        startTime: startTimeUtcIso,
        endTime: endTimeUtcIso,
        // endTime: dayjs(endTime).format("YYYY-MM-DDTHH:mm:ss"),
      }));

      dispatch(
        setNewSurveyAction({
          survey: {
            ...newSurveyLocal?.survey,
            surveyDate: dayjs(selectedDate).format("YYYY-MM-DD"),
            startTime: startTimeUtcIso,
            endTime: endTimeUtcIso,
          },
        }),
      );

      // for events form
      setSurveyEventDetail((prevState: any) => ({
        ...prevState,
        startDate: startTimeUtcIso,
        endDate: endTimeUtcIso,
      }));

      dispatch(
        setNewSurveyEventAction({
          ...newEventLocal,
          startDate: startTimeUtcIso,
          endDate: endTimeUtcIso,
        }),
      );
    }
  }, [selectedDate]);

  // Combine selectedDate and selectedResource updates into a single effect
  useEffect(() => {
    if (selectedDate && selectedResource) {
      const startTimeUtcIso = toClientUtcIsoFromWallClock(selectedDate);
      const endTimeUtcIso = dayjs(startTimeUtcIso)
        .add(60, "minute")
        .toISOString();

      const updatedEvent = {
        ...surveyEventDetail,
        startDate: startTimeUtcIso,
        endDate: endTimeUtcIso,
        surveyorId: selectedResource?.id,
        assignTo: selectedResource?.name,
      };

      setSurveyEventDetail(updatedEvent);
      dispatch(setNewSurveyEventAction(updatedEvent));
    }
  }, [selectedDate, selectedResource]);

  const handleEventInputChange = (field: string, value: any) => {
    setSurveyEventDetail((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));

    dispatch(
      setNewSurveyEventAction({
        ...newEventLocal,
        [field]: value,
      }),
    );
    resetEventValidator(field);
  };

  const handleInputChange = (field: string, value: any) => {
    // If the startTime is being updated, update the end_time dynamically
    if (field === "startTime" && value) {
      const newStartTime = dayjs.utc(value).tz(clientTimeZone);

      // Get the previous start and end times
      const prevStartTime = dayjs
        .utc(newSurveyLocal?.survey?.startTime)
        .tz(clientTimeZone);
      const prevEndTime = dayjs
        .utc(newSurveyLocal?.survey?.endTime)
        .tz(clientTimeZone);

      // Default to 1 hour if no previous end time
      const timeDiffInMinutes = prevEndTime.isValid()
        ? prevEndTime.diff(prevStartTime, "minute")
        : 60;
      // before
      // const newEndTime = newStartTime
      //   .add(timeDiffInMinutes, "minute")
      //   .format("YYYY-MM-DDTHH:mm:ss");

      // after
      // ✅ AFTER
      const newEndTime = dayjs(newStartTime)
        .add(timeDiffInMinutes, "minute")
        .utc()
        .toISOString();

      // Update both startTime and end_time
      setSurveyDetail((prevState) => ({
        ...prevState,
        startTime: value,
        endTime: newEndTime,
      }));

      dispatch(
        setNewSurveyAction({
          survey: {
            ...newSurveyLocal?.survey,
            startTime: value,
            endTime: newEndTime,
          },
        }),
      );
    } else {
      setSurveyDetail((prevState) => ({
        ...prevState,
        [field]: value,
      }));

      dispatch(
        setNewSurveyAction({
          survey: {
            ...newSurveyLocal?.survey,
            [field]: value,
          },
        }),
      );
    }

    resetValidator(field);
  };

  // useEffect(() => {
  //   const { startTime, endTime } = newSurveyLocal?.survey || {};
  //   if (startTime) {
  //     onBlurAction({ target: { id: "startTime", value: startTime } });
  //   }
  //   if (endTime) {
  //     onBlurAction({ target: { id: "endTime", value: endTime } });
  //   }
  // }, [newSurveyLocal?.survey?.startTime, newSurveyLocal?.survey?.endTime]);

  const hideHandler = () => {
    props.onHide();
    resetAllValidator();
    handleClear();
    dispatch(setSingleSurveyAction(""));
    onHide();
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        const payload = {
          ...surveyDetail,

          startTime: dayjs
            .utc(surveyDetail.startTime)
            .startOf("minute")
            .toISOString(),

          endTime: dayjs
            .utc(surveyDetail.endTime)
            .startOf("minute")
            .toISOString(),
        };
        if (selectedSurvey) {
          dispatch(updateSurveyDiaryAction({ ...payload, id: selectedSurvey }));
        } else {
          dispatch(addSurveyDiaryAction(payload));
        }
      } else {
        console.log("API Error", error);
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const handleSubmitEvent = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkEventValidator();
    setIsEventActionCalled(true);
  };

  useEffect(() => {
    if (isEventActionCalled) {
      if (!isEventError() && eventErrors !== null && isEventActionCalled) {
        if (selectedSurvey) {
          dispatch(
            updateSurveyEventAction({
              ...surveyEventDetail,
              id: selectedSurvey,
            }),
          );
        } else {
          dispatch(addSurveyEventAction(surveyEventDetail));
        }
      } else {
        console.log("API Error", error);
      }
      setIsEventActionCalled(false);
    }
  }, [isEventActionCalled]);

  const onBlurAction = (e: any) => {
    console.log("onBlurAction called for", e.target.id);
    checkValidator(e.target.id);
  };

  const onEventBlurAction = (e: any) => {
    checkEventValidator(e.target.id);
  };
  // Surveyor Form Elements
  const updateField = surveryAllFields.map((field) => {
    if (field.id === "surveyorId") {
      return {
        ...field,
        options: [
          { label: "Self", id: userProfile?.user?.staff_id }, // Adding the extra dropdown option
          ...surveyorList.map((item: any) => ({
            label: item?.name,
            id: item?.staff_id,
          })),
        ],
      };
    }

    return field;
  });

  useEffect(() => {
    if (selectedSurvey) {
      if (tabValue === "0") {
        dispatch(getSingleSurveyEventAction(selectedSurvey));
      } else {
        dispatch(getSingleSurveyAction(selectedSurvey));
      }
    }
  }, [selectedSurvey]);

  useEffect(() => {
    if (surveyDiaryEventDetail || isClickReset) {
      const startEventUtcIso = toUtcIsoFromApiDate(
        surveyDiaryEventDetail?.start_date,
      );
      const endEventUtcIso = toUtcIsoFromApiDate(
        surveyDiaryEventDetail?.end_date,
      );

      dispatch(
        setNewSurveyEventAction({
          ...surveyDiaryEventDetail,
          surveyorId: surveyDiaryEventDetail?.surveyor_id,
          assignTo: selectedResource?.name,
          eventType: surveyDiaryEventDetail?.event_type,
          event: surveyDiaryEventDetail?.event,
          startDate: startEventUtcIso,
          endDate: endEventUtcIso,
        }),
      );

      setSurveyEventDetail((prevDetails: any) => ({
        ...prevDetails,
        surveyorId: surveyDiaryEventDetail?.surveyor_id,
        assignTo: selectedResource?.name,
        eventType: surveyDiaryEventDetail?.event_type,
        event: surveyDiaryEventDetail?.event,
        startDate: startEventUtcIso,
        endDate: endEventUtcIso,
      }));
    }
  }, [surveyDiaryEventDetail, isClickReset]);

  useEffect(() => {
    if (isClickReset) {
      if (value === "0") {
        handleEventClear();
      } else {
        handleClear();
      }
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  const handleEventClear = () => {
    if (surveyEventDetail?.id) {
      setSurveyEventDetail(surveyEventDetail);
    } else {
      setSurveyEventDetail(initialSurveyEventLocalState);
    }
    dispatch(resetNewSurveyEventAction());
    resetAllEventValidator();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    setIsClickReset(false);
    setAlertModelShow(false);
  };

  const handleClear = () => {
    if (isReassignAction) {
      const description = surveyDiaryDetail?.description;

      const updatedSurvey = {
        ...initialSurveyDetail,
        leadId: surveyDiaryDetail?.leadId,
        customer_name: surveyDiaryDetail?.customerName,
        description: description,
        surveyorId: null,
        surveyType: null,
      };

      setSurveyDetail(updatedSurvey);

      dispatch(
        setNewSurveyAction({
          survey: updatedSurvey,
        }),
      );
    } else if (surveyDiaryDetail?.id) {
      setSurveyDetail(surveyDiaryDetail);

      dispatch(
        setNewSurveyAction({
          survey: surveyDiaryDetail,
        }),
      );
    } else {
      setSurveyDetail(initialSurveyDetail);
      dispatch(resetNewSurveyAction());
    }

    dispatch(setAddSurveyDiaryResponse(false));
    dispatch(setUpdateSurveyDiaryResponse(false));
    resetAllValidator();
    dispatch(setNotificationAction({ message: [], severity: "error" }));

    setIsClickReset(false);
    setAlertModelShow(false);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleRemoveEvent = () => {
    dispatch(deleteSurveyEventAction(selectedSurvey));
  };

  const isTenantAdmin =
    user?.user?.roles?.includes("Owner") ||
    user?.user?.roles?.includes("TENANT");

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={value === "0" ? "Add Events" : title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        popupBg="#fff"
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            {(permissions?.["Lead:Survey"]?.create || isTenantAdmin) &&
              ((value === "0" && !isEventFormDisabled) ||
                (value !== "0" && !isAppointmentFormDisabled)) && (
                <>
                  <img
                    onClick={(e: any) =>
                      value === "0" ? handleSubmitEvent(e) : handleSubmit(e)
                    }
                    src={checkedIcon}
                    className={classes.checkicons}
                    alt="save"
                  />
                  <img
                    onClick={openClearPopup}
                    src={deleteIcon}
                    className={classes.deleteicons}
                    alt="delete"
                  />
                </>
              )}
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            {/* ✅ Go to Customer button —  */}
            {!isDashboard && leadDetails?.lead?.generated_id && onGoToCustomer && (
              <CustomButton
                style={{
                  padding: "4px 14px",
                  minWidth: 80,
                  height: "32px",
                  fontSize: 13,
                  marginRight: 8,
                }}
                variant="outlined"
                title="Go to Customer"
                onClick={() => onGoToCustomer(leadDetails.lead.generated_id)}
              />
            )}
            {(permissions?.["Lead:Survey"]?.delete || isTenantAdmin) &&
              surveyDiaryEventDetail?.id &&
              value === "0" && (
                <CustomButton
                  style={{
                    padding: "4px 14px",
                    minWidth: 80,
                    height: "32px",
                    fontSize: 13,
                  }}
                  variant="outlined"
                  title="Delete Event"
                  onClick={handleRemoveEvent}
                />
              )}
            {surveyDiaryDetail?.id && value === "1" && (
              <>
                {/* Email Button Group with Dropdown */}
                <ButtonGroup variant="outlined" style={{ marginRight: 8 }}>
                  <Button
                    style={{
                      padding: "4px 14px",
                      minWidth: 80,
                      height: "32px",
                      fontSize: 13,
                    }}
                    onClick={(e) => setEmailAnchorEl(e.currentTarget)}
                    disabled={
                      leadDetails?.lead?.customer_email
                        ? isEventFormDisabled
                        : true
                    } // Disable if no customer email
                  >
                    Send Email
                  </Button>
                </ButtonGroup>
                <Menu
                  id="email-menu"
                  anchorEl={emailAnchorEl}
                  open={Boolean(emailAnchorEl)}
                  onClose={() => setEmailAnchorEl(null)}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                >
                  {allEmailTemplates.map((template: any, idx: number) => (
                    <MenuItem
                      key={idx}
                      onClick={() => handleEmailTemplateSelect(template)}
                    >
                      {template?.template_name}
                    </MenuItem>
                  ))}
                </Menu>

                {/* SMS Button Group with Dropdown */}
                <ButtonGroup variant="outlined">
                  <Button
                    style={{
                      padding: "4px 14px",
                      minWidth: 80,
                      height: "32px",
                      fontSize: 13,
                    }}
                    onClick={(e) => setSmsAnchorEl(e.currentTarget)}
                    disabled={
                      leadDetails?.lead?.customer_phone
                        ? isEventFormDisabled
                        : true
                    } // Disable if no customer phone number
                  >
                    Send SMS
                  </Button>
                </ButtonGroup>
                <Menu
                  id="sms-menu"
                  anchorEl={smsAnchorEl}
                  open={Boolean(smsAnchorEl)}
                  onClose={() => setSmsAnchorEl(null)}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                >
                  {smsTemplates.map((template: any, idx: number) => (
                    <MenuItem
                      key={idx}
                      onClick={() => handleSmsTemplateSelect(template)}
                    >
                      {template.template_name}
                    </MenuItem>
                  ))}
                </Menu>
              </>
            )}
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 4px 0px 4px !important" }}>
          <DialogContentText className={classes.formAddBox}>
            <>
              <Notification />
              {tabValue === "0" && (
                <Tabs
                  centered
                  value={value}
                  // disabled={tabValue === "1" ? true : false}
                  onChange={handleChange}
                  textColor="secondary"
                  indicatorColor="secondary"
                  aria-label="secondary tabs example"
                  variant="standard"
                  sx={{
                    background: "#e5f4f1",
                    fontSize: "14px",
                    fontWeight: 600,
                    marginBottom: "16px",
                    borderRadius: "5px",
                    border: "1px solid #CFCFCF",
                  }}
                >
                  <Tab value="0" label="Events" />
                  <Tab value="1" label="Appointments" />
                </Tabs>
              )}
              {value === "0" ? (
                <>
                  <Grid
                    container
                    spacing={0.5}
                    sx={{
                      background: "#e5f4f1",
                      padding: "16px",
                      borderRadius: "5px",
                      border: "1px solid #CFCFCF",
                    }}
                  >
                    {surveryEventAllFields.map((field, i) => {
                      return (
                        <FormField
                          key={field.id}
                          onPaste={(e) => e.preventDefault()}
                          onKeyDown={(event: any) => {
                            console.log(
                              "event log-",
                              event,
                              event.target.value + event.key,
                            );
                            if (
                              event.keyCode === 8 ||
                              event.keyCode === 9 ||
                              event.keyCode === 37 ||
                              event.keyCode === 38 ||
                              event.keyCode === 39 ||
                              event.keyCode === 40 ||
                              event.keyCode === 18 ||
                              event.keyCode === 17 ||
                              event.ctrlKey
                            )
                              return event;
                            if (
                              field?.patternAllowed &&
                              !field?.patternAllowed.test(event.key)
                            ) {
                              event.preventDefault();
                            } else if (
                              field?.patternAllowed &&
                              !field?.patternAllowed.test(
                                event.target.value + event.key,
                              )
                            ) {
                              event.preventDefault();
                            }
                          }}
                          {...{
                            ...field,
                            ...{
                              variant: "outlined", // Adding this variant prop
                              ...((field?.id === "surveyorId" ||
                                field?.id === "surveyType") && {
                                disabled:
                                  userProfile?.user?.roles?.includes(
                                    "TENANT",
                                  ) ||
                                  userProfile?.user?.roles?.includes("Admin") ||
                                  userProfile?.user?.roles?.includes("Owner") ||
                                  permissions?.["Lead:Survey"]?.create ||
                                  permissions?.["Lead:Survey"]?.update
                                    ? surveyorType === "self" &&
                                      field?.id === "surveyorId"
                                      ? true
                                      : false || isEventFormDisabled
                                    : true,
                              }),
                              ...((field?.id === "startDate" ||
                                field?.id === "endDate") && {
                                disabled: isEventFormDisabled,
                              }),
                              // disabled :(field?.id==='startTime' || field?.id==='endTime') && disabledForm,
                              InputProps: {
                                ...(field?.inputProps && field?.inputProps),
                                sx: { height: "36px" },
                                autocomplete: "user-new-field",
                              },
                              value: newEventLocal
                                ? newEventLocal[field.id]
                                : "",
                              inSingleGridForm: true,
                              isNonMarginTop: true,
                              minDate:
                                field.id === "endDate"
                                  ? newEventLocal?.startDate &&
                                    newEventLocal?.startDate
                                  : undefined,
                              minTime:
                                field.id === "endDate"
                                  ? newEventLocal?.startDate &&
                                    newEventLocal?.startDate
                                  : undefined,
                              onBlur: onEventBlurAction,
                              onChange: (e: any) =>
                                handleEventInputChange(
                                  field.id,
                                  e.target.value,
                                ), // Call onChange prop
                              error: eventErrors && eventErrors[field?.id],
                              helperText: eventErrors && eventErrors[field?.id],
                            },
                          }}
                        />
                      );
                    })}
                  </Grid>
                </>
              ) : (
                <>
                  {!canEditAppointmentForLeadStatus && normalizedLeadStatus && (
                    <Alert
                      severity="warning"
                      sx={{ marginBottom: "12px", borderRadius: "6px" }}
                    >
                      This lead is already in {normalizedLeadStatus} stage, so
                      appointment add/updates are not allowed.
                    </Alert>
                  )}
                  <Grid
                    container
                    direction="row"
                    spacing={0.5}
                    sx={{
                      background: "#e5f4f1",
                      padding: "16px",
                      borderRadius: "5px",
                      border: "1px solid #CFCFCF",
                    }}
                  >
                    {updateField.map((field, i) => {
                      return (
                        <FormField
                          key={i}
                          onPaste={(e) => e.preventDefault()}
                          onKeyDown={(event: any) => {
                            console.log(
                              "event log-",
                              event,
                              event.target.value + event.key,
                            );
                            if (
                              event.keyCode === 8 ||
                              event.keyCode === 9 ||
                              event.keyCode === 37 ||
                              event.keyCode === 38 ||
                              event.keyCode === 39 ||
                              event.keyCode === 40 ||
                              event.keyCode === 18 ||
                              event.keyCode === 17 ||
                              event.ctrlKey
                            )
                              return event;
                            if (
                              field?.patternAllowed &&
                              !field?.patternAllowed.test(event.key)
                            ) {
                              event.preventDefault();
                            } else if (
                              field?.patternAllowed &&
                              !field?.patternAllowed.test(
                                event.target.value + event.key,
                              )
                            ) {
                              event.preventDefault();
                            }
                          }}
                          {...{
                            ...field,
                            ...{
                              variant: "outlined", // Adding this variant prop
                              ...((field?.id === "surveyorId" ||
                                field?.id === "surveyType") && {
                                disabled:
                                  userProfile?.user?.roles?.includes(
                                    "TENANT",
                                  ) ||
                                  userProfile?.user?.roles?.includes("Admin") ||
                                  userProfile?.user?.roles?.includes("Owner") ||
                                  permissions?.["Lead:Survey"]?.create ||
                                  permissions?.["Lead:Survey"]?.update
                                    ? surveyorType === "self" &&
                                      field?.id === "surveyorId"
                                      ? true
                                      : false || isAppointmentFormDisabled
                                    : true,
                              }),
                              ...((field?.id === "startTime" ||
                                field?.id === "endTime") && {
                                disabled: isAppointmentFormDisabled,
                              }),
                              inSingleGridForm: true,
                              InputProps: {
                                ...(field?.inputProps && field?.inputProps),
                                sx: { height: "36px" },

                                ...((field?.id === "customer_name" ||
                                  field?.id === "description") && {
                                  disabled:
                                    field?.editReadOnly ||
                                    isAppointmentFormDisabled,
                                }),

                                autocomplete: "user-new-field",
                              },
                              isNonMarginTop: true,
                              GridFieldStyle: {
                                marginTop:
                                  field?.id === "customer_name"
                                    ? "6px !important"
                                    : field?.id === "description"
                                      ? "6px !important"
                                      : "0px !important",
                              },
                              value: newSurveyLocal?.survey
                                ? newSurveyLocal?.survey[field.id]
                                : "",
                              minDate:
                                field.id === "endTime" &&
                                newSurveyLocal?.survey?.endTime
                                  ? newSurveyLocal?.survey?.startTime &&
                                    newSurveyLocal?.survey?.startTime
                                  : undefined,
                              minTime:
                                field.id === "endTime" &&
                                newSurveyLocal?.survey?.endTime
                                  ? newSurveyLocal?.survey?.startTime &&
                                    newSurveyLocal?.survey?.startTime
                                  : undefined,
                              onBlur: onBlurAction,
                              onChange: (e: any) =>
                                handleInputChange(field.id, e.target.value), // Call onChange prop
                              error: !isAppointmentFormDisabled
                                ? field.id === "endTime" &&
                                  newSurveyLocal?.survey?.endTime
                                  ? error && error[field?.id]
                                  : field.id !== "endTime"
                                    ? error && error[field?.id]
                                    : ""
                                : false,
                              helperText: !isAppointmentFormDisabled
                                ? field.id === "endTime" &&
                                  newSurveyLocal?.survey?.endTime
                                  ? error && error[field?.id]
                                  : field.id !== "endTime"
                                    ? error && error[field?.id]
                                    : ""
                                : "",
                            },
                          }}
                        />
                      );
                    })}
                  </Grid>
                </>
              )}
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageSurveyAppointment;
